<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { post } from "@/utils";
import type { Component, ShowFormParameters } from "@/global";
import { useFormModel } from "@/hooks";
import type { InputAlign } from "@nutui/nutui";
import { computed, inject, ref } from "vue";

interface CascaderData {
  display: string;
  value: string;
}

const props = defineProps<{
  modelValue?: CascaderData;
  labelFieldKey: string;
  placeholder?: string;
  inputAlign?: InputAlign;
}>();

const emit = defineEmits(["update:modelValue", "change"]);
const cascaderValue = computed(() =>
  props.modelValue ? props.modelValue.value.split(",") : undefined
);

const displayValue = computed(() =>
  props.modelValue ? props.modelValue.display : ""
);

const showParams = inject<ShowFormParameters>("showParams")!;
const cmp = inject<Component>("component")!;

const show = ref(false);

async function lazyLoad(node: any, resolve: (data: any) => void) {
  const { value } = node;
  const parentId = node.root ? undefined : value;
  const level = node.root ? 1 : node.level + 2;
  const { data } = await post(`${showParams.serviceType}/CascaderGetData`, {
    pageId: showParams.pageId,
    key: cmp.key,
    level,
    parentId,
  });

  if (data) {
    resolve(data);
  }
}

async function change(values?: string[]) {
  show.value = false;
  const value = values ? values.join(",") : undefined;
  emit("change", value);
}

const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <div class="mp-cascader">
    <nut-input
      :modelValue="displayValue"
      :placeholder="placeholder"
      :inputAlign="inputAlign"
      :border="false"
      readonly
      type="text"
      @click="show = true"
    />
    <nut-cascader
      v-model:visible="show"
      :modelValue="cascaderValue"
      v-bind="$attrs"
      value-key="Id"
      :text-key="labelFieldKey"
      lazy
      :lazy-load="lazyLoad"
      @change="change"
    />
  </div>
</template>
<style lang="scss">
.mp-cascader {
  width: 100%;
}
</style>
